import { useContext, memo } from 'react';
import { useIntl } from 'react-intl';
import { GlobalFooterContext } from '../../context/GlobalFooterContext.js';
import { titleMessages } from '../../messages.js';
import { messages } from '../../shared/messages/navigation.js';
import { legalAgreementUrl, legalHomepageUrl, aboutUrl, careersUrl, affiliatesUrl, blogUrl, pressUrl, securityUrl, investorsUrl, vendors, legalGermanyHomepageUrl, cookiePolicyUrl, digitalAssetDisclosuresUrl, modernSlaveryStatementUrl, impressumUrl } from '../../shared/utils/links.js';
import CDSFooterLink from '../CDSFooterLink.js';
import CookiePreferences from '../CookiePreferences.js';
import MarketingTrackingPreferences from '../MarketingTrackingPreferences.js';
import FooterColumn from './FooterColumn.js';
import { jsxs, jsx } from 'react/jsx-runtime';
function CompanyColumn() {
  const _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  const _useContext = useContext(GlobalFooterContext),
    isUserFromCountry = _useContext.isUserFromCountry,
    isUserFromCBPaymentsCountries = _useContext.isUserFromCBPaymentsCountries;
  const isCBPaymentsCountriesUser = isUserFromCBPaymentsCountries();
  const isUKUser = isUserFromCountry('GB');
  const isGermanyUser = isUserFromCountry('DE');
  const isInternational = isCBPaymentsCountriesUser || isGermanyUser || isUKUser;
  const defaultLegalUrl = isInternational ? legalAgreementUrl : legalHomepageUrl;
  return /*#__PURE__*/jsxs(FooterColumn, {
    heading: formatMessage(messages.company),
    children: [/*#__PURE__*/jsx(CDSFooterLink, {
      accessibilityLabel: formatMessage(titleMessages.about),
      href: aboutUrl,
      children: formatMessage(messages.about)
    }), /*#__PURE__*/jsx(CDSFooterLink, {
      accessibilityLabel: formatMessage(titleMessages.careers),
      href: careersUrl,
      children: formatMessage(messages.careers)
    }), !isUKUser && /*#__PURE__*/jsx(CDSFooterLink, {
      accessibilityLabel: formatMessage(titleMessages.affiliates),
      href: affiliatesUrl,
      children: formatMessage(messages.affiliates)
    }), /*#__PURE__*/jsx(CDSFooterLink, {
      accessibilityLabel: formatMessage(titleMessages.blog),
      href: blogUrl,
      children: formatMessage(messages.blog)
    }), /*#__PURE__*/jsx(CDSFooterLink, {
      accessibilityLabel: formatMessage(titleMessages.press),
      href: pressUrl,
      children: formatMessage(messages.press)
    }), /*#__PURE__*/jsx(CDSFooterLink, {
      accessibilityLabel: formatMessage(titleMessages.security),
      href: securityUrl,
      children: formatMessage(messages.security)
    }), !isUKUser && /*#__PURE__*/jsx(CDSFooterLink, {
      accessibilityLabel: formatMessage(titleMessages.investors),
      href: investorsUrl,
      children: formatMessage(messages.investors)
    }), /*#__PURE__*/jsx(CDSFooterLink, {
      accessibilityLabel: formatMessage(titleMessages.vendors),
      href: vendors,
      children: formatMessage(messages.vendors)
    }), /*#__PURE__*/jsx(CDSFooterLink, {
      accessibilityLabel: formatMessage(titleMessages.legalPrivacy),
      href: isGermanyUser ? legalGermanyHomepageUrl : defaultLegalUrl,
      children: formatMessage(messages.legalPrivacy)
    }), /*#__PURE__*/jsx(CDSFooterLink, {
      accessibilityLabel: formatMessage(titleMessages.cookiePolicy),
      href: cookiePolicyUrl,
      children: formatMessage(messages.cookiePolicy)
    }), /*#__PURE__*/jsx(CookiePreferences, {}), /*#__PURE__*/jsx(MarketingTrackingPreferences, {}), /*#__PURE__*/jsx(CDSFooterLink, {
      accessibilityLabel: formatMessage(titleMessages.digitalAssetDisclosures),
      href: digitalAssetDisclosuresUrl,
      children: formatMessage(messages.digitalAssetDisclosures)
    }), (isCBPaymentsCountriesUser || isUKUser) && /*#__PURE__*/jsx(CDSFooterLink, {
      accessibilityLabel: formatMessage(titleMessages.modernSlaveryStatement),
      href: modernSlaveryStatementUrl,
      children: formatMessage(messages.modernSlaveryStatement)
    }), isGermanyUser && /*#__PURE__*/jsx(CDSFooterLink, {
      accessibilityLabel: formatMessage(titleMessages.imprint),
      href: impressumUrl,
      children: formatMessage(messages.imprint)
    })]
  });
}
const CompanyColumn$1 = /*#__PURE__*/memo(CompanyColumn);
export { CompanyColumn$1 as default };
//# sourceMappingURL=CompanyColumn.js.map
